import router from './router'
import { getToken } from './utils/auth'
import store from "./store";

const whiteList = ['/sign-in', '/sign-up', '/404', '/oauth2.0/success']
router.beforeEach((to, from , next) => {
    // 验证身份和跳转的逻辑
    // token存在的情况
    if (getToken()) {
        // 访问登录页面直接跳转到首页
        if (to.path === '/sign-in') {
            next({path: '/'})
            //其它页面直接访问
        } else {
            // userStore只能在setup内部生成，这里直接像main.js一样引入store就行
            // 要不要加这一步？
            store.dispatch("GetInfo");
            store.commit('setLoginStatus', true);
            next()
        }
        next();
        // 没有token的情况
    } else {
        store.commit('setLoginStatus', false);
        store.commit('setToken', '');
        store.commit('setUserId', '');
        store.commit('setUsername', '');
        store.commit('setUserPic', '');
        // 如果访问的页面在白名单中，直接跳转
        if (whiteList.indexOf(to.path) !== -1) {
            next()
            //如果访问的页面不在白名单中，跳转到登录页面
        } else {
            next({path :'/sign-in'})
        }
    }
})
